import React, { useState } from 'react'
import './Footer.css'
import { useNavigate } from 'react-router-dom'
import { WHATSAPP_CHAT_URL, WHATSAPP_COMMUNITY_URL, INSTAGRAM_URL, CONTACT_EMAIL } from '../data/contact'
import { submitEnquiry } from '../lib/enquiries'

function Footer() {
  const navigate = useNavigate();

  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterState, setNewsletterState] = useState(null); // { ok, text }
  const [joining, setJoining] = useState(false);

  const handleJoin = async (e) => {
    e.preventDefault();
    if (!newsletterEmail.trim()) return;

    setJoining(true);
    const res = await submitEnquiry({ type: 'newsletter', email: newsletterEmail });
    setNewsletterState({ ok: res.success, text: res.success ? "You're on the list — welcome." : res.message });
    if (res.success) setNewsletterEmail('');
    setJoining(false);
  };

  return (
    <footer className="footer">
      <div className="footer-content">

        {/* Brand Column */}
        <div className="footer-col footer-col--brand">
          <img src="/ok2.png" alt="Elaichi & Love" className="footer-logo" onError={e => { e.target.src = '/footerlogo.PNG'; }} />
          <p className="footer-tagline">Where Ancient Wisdom Meets Modern Wellness</p>
          <p className="footer-address">Glasgow, Scotland</p>
          <a className="footer-email" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </div>

        {/* Explore Column */}
        <div className="footer-col">
          <p className="footer-col-heading">EXPLORE</p>
          <a className="footer-link" onClick={() => navigate('/')}>Home</a>
          <a className="footer-link" onClick={() => navigate('/allproduct')}>Products</a>
          <a className="footer-link" onClick={() => navigate('/customize')}>Personalised Products</a>
          <a className="footer-link" onClick={() => navigate('/about')}>Our Story</a>
          <a className="footer-link" onClick={() => navigate('/events')}>Events & Clubs</a>
          <a className="footer-link" onClick={() => navigate('/corporate-events')}>Corporate Events</a>
          <a className="footer-link" onClick={() => navigate('/myorders')}>Track Your Order</a>
        </div>

        {/* Connect Column */}
        <div className="footer-col">
          <p className="footer-col-heading">CONNECT</p>
          <a className="footer-link" onClick={() => navigate('/contact')}>Contact Us</a>
          <a className="footer-link" href={WHATSAPP_CHAT_URL} target="_blank" rel="noopener noreferrer">WhatsApp Us</a>
          <a className="footer-link" href={WHATSAPP_COMMUNITY_URL} target="_blank" rel="noopener noreferrer">WhatsApp Community</a>
          <a className="footer-link" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">Instagram</a>
          <a className="footer-link" href="https://docs.google.com/forms/d/e/1FAIpQLSf2LNFSBk9e7QgJDjyH0GS-5szr59N9x0w3rrr_Ncy35PI6RA/viewform" target="_blank" rel="noopener noreferrer">Careers</a>
        </div>

        {/* Legal & Newsletter Column */}
        <div className="footer-col">
          <p className="footer-col-heading">JOIN THE MOVEMENT</p>
          <form className="newsletter-form" onSubmit={handleJoin}>
            <input
              type="email"
              placeholder="Your email"
              className="email-input"
              value={newsletterEmail}
              onChange={(e) => setNewsletterEmail(e.target.value)}
              disabled={joining}
              required
            />
            <button className="join-btn" type="submit" disabled={joining}>{joining ? '…' : 'JOIN'}</button>
          </form>
          {newsletterState && (
            <p className={`newsletter-msg ${newsletterState.ok ? 'is-ok' : 'is-error'}`}>{newsletterState.text}</p>
          )}
          <div className="footer-legal-links">
            <a className="footer-link footer-link--small" onClick={() => navigate('/terms')}>Terms of Use</a>
            <a className="footer-link footer-link--small" onClick={() => navigate('/privacy')}>Privacy Policy</a>
            <a className="footer-link footer-link--small" onClick={() => navigate('/refund')}>Refund Policy</a>
            <a className="footer-link footer-link--small" onClick={() => navigate('/shipping')}>Shipping Policy</a>
          </div>
        </div>
      </div>

      <div className="footer-brand-img">
        <img src="/logosecondary.png" alt="Elaichi & Love" onError={e => { e.target.src = '/footerlogo.PNG'; }} />
      </div>

      <div className="footer-bottom">
        <p>© 2025 Elaichi & Love · Glasgow, Scotland · UK's first food revolution</p>
      </div>
    </footer>
  )
}

export default Footer
